<template>
  <div class="calendar-match-active-time" ref="calendarMatch" :class="dynamicClasses">
    <div class="date" :style="dateStyles">
      <span class="date__dayofweek">{{ formatedDate.dayOfWeek }}</span>
      <span class="date__day">{{ date.getUTCDate() }}</span>
      <span class="date__month">{{ formatedDate.month }}</span>
    </div>
    <div class="game">
      <!--   active time   -->
      <div class="game__active-time">
        <div class="game__active-time__status-and-teams">
          <div class="game__active-time__status-and-teams__status">
            <div v-if="isLive" class="live">
              <div />
              <div>LIVE</div>
            </div>

            <div v-else-if="gameStatus === 4" class="pre-match">{{ time }} HRS</div>
            <div v-else class="ended">FINAL</div>
          </div>
          <div class="game__active-time__status-and-teams__teams">
            <div class="game__active-time__status-and-teams__teams__logo">
              <img
                :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teamLeft.team_id + '.png'"
                alt="logo del equipo local"
              />
            </div>
            <div class="game__active-time__status-and-teams__teams__score">
              <template v-if="gameStatus === 4 && isLive == 0">VS</template>
              <template v-else>{{ score[0] }} - {{ score[1] }}</template>
            </div>
            <div class="game__active-time__status-and-teams__teams__logo">
              <img
                :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teamRight.team_id + '.png'"
                alt="logo del equipo visitante"
              />
            </div>
          </div>
        </div>
        <div class="actions__info-button" role="button" @click="onClickViewStats">
          <span>Ver</span>
        </div>
        <template v-if="isLive || gameStatus !== 4">
          <div class="game__active-time__time-info">
            <ActiveAndInactive :time="game.time_active.home_te" :is-live="isLive" />
            <ActiveAndInactive :time="game.time_active.visiting_te" :is-live="isLive" />
          </div>
          <div class="game__active-time__total is-active" :style="taTotalStyle">
            {{ game.time_active.total_te }}
          </div>
          <div class="game__active-time__time-info">
            <ActiveAndInactive :is-active="false" :time="game.time_active.home_ti" :is-live="isLive" />
            <ActiveAndInactive :is-active="false" :time="game.time_active.visiting_ti" :is-live="isLive" />
          </div>
          <div class="game__active-time__total" :class="{ 'is-live': isLive }">
            {{ game.time_active.total_ti }}
          </div>
        </template>
        <div v-else class="game__active-time__time-info-pre-match">
          <div>
            <ActiveAndInactive is-pre-match :time="game.time_active.home_ta_average" />
          </div>
          <div>
            <ActiveAndInactive is-pre-match :time="game.time_active.visiting_ta_average" />
          </div>
        </div>
      </div>
      <div class="separator" />
      <!--   others   -->
      <div class="game__others" :class="{ 'is-pre-match': isPreMatch }">
        <div class="game__others__text">
          <template v-if="isPreMatch">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/tmp.png" alt="" />
            <div>{{ refAbbreviation }}</div>
          </template>
          <template v-else>Otros:</template>
        </div>
        <div class="game__others__minutes">
          <template v-if="isPreMatch">
            <p>
              <span>T.E. Promedio: </span>
              <span>{{ game.time_active.referee_ta_average }}</span>
            </p>
          </template>
          <template v-else>
            {{ game.time_active.others }}
          </template>
        </div>
      </div>
      <div v-if="isPreMatch" class="game__x-TA">
        <div>xTE</div>
        <div>=</div>
        <div>{{ game.time_active.xta }}</div>
      </div>
      <div v-else class="game__referee">
        <div class="game__referee__icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/tmp.png" alt="" />
        </div>
        <div class="v-separator"></div>
        <div class="game__referee__name">
          {{ changeNameReferee(game.referee_name) || 'N/A' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
export default {
  name: 'ActiveTimeCalendarMatch',
  components: {
    ActiveAndInactive: () => import('@/components/ActiveTime/ActiveAndInactiveTimeCalendar'),
  },
  props: {
    isPremiumUser: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#fff',
    },
    predictions: {
      type: Boolean,
      default: true,
    },
    background: {
      type: String,
      default: '#DBE3E6',
    },
    backgroundLive: {
      type: String,
      default: '#77a405',
    },
    isGameLive: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: '20:30',
    },
    date: {
      type: Date,
      default: () => new Date(),
    },
    teamRight: {
      type: Object,
      required: true,
    },
    teamLeft: {
      type: Object,
      required: true,
    },
    gameStatus: {
      type: Number,
      required: true,
    },
    score: {
      type: Array,
      default: () => [],
    },
    game: {
      type: Object,
      default: () => {},
    },
    percentages: {
      type: Array,
      default: () => [],
    },
    homeGoals: {
      type: Array,
      default: () => [],
    },
    visitingGoals: {
      type: Array,
      default: () => [],
    },
    probabilities: {
      type: [Object, null],
      default: () => null,
    },
    containerWidth: {
      type: Number,
      default: 634,
    },
    isSingleGame: {
      type: Boolean,
      default: false,
    },
    isCup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusOptions: {
        0: 'pending',
        1: 'live',
        2: 'finished',
      },
      probsTitles: ['GANA', 'EMPATE', 'GANA'],
      xgTitles: ['Goles', 'xG'],
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getSeasonSelected']),
    ...mapState('loginGeneral', ['tournamentsForMediaPlayer']),
    hasPenalties() {
      return this.game.penalties_score_home_team || this.game.penalties_score_visiting_team;
    },
    refAbbreviation() {
      if (this.game.referee_name) {
        var nameRefereePrint = 'Sin designar';
        if (this.game.referee_name != 'Sin designar') {
          var nameTrim = this.game.referee_name.trim();
          var auxReferee = nameTrim.split(', ');
          var apellidoAuxReferee = auxReferee[0].split(' ');
          var nameAuxReferee = auxReferee[1].split(' ');
          var auxNameInitials = '';
          for (let index = 0; index < nameAuxReferee.length; index++) {
            auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
          }
          nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
        }
        return nameRefereePrint;
      }
      return 'Sin designar';
    },
    taTotalStyle() {
      let total =
        this.game.time_active && this.game.time_active.total_te
          ? Number(this.game.time_active.total_te.split(':')[0])
          : 0;
      return {
        'background-color': this.isLive ? '#cbfb48' : total >= 54 ? '#8b0' : total >= 50 ? '#d2d3d4' : '#dc4368',
        color: this.isLive ? '#132839' : total >= 54 || total < 50 ? 'white' : '#132839',
      };
    },
    xgTitlesReversed() {
      return this.xgTitles.map(i => i).reverse();
    },
    leftXgConent() {
      return this.homeGoals;
    },
    rightXgConent() {
      return this.visitingGoals.map(i => i).reverse();
    },
    dateStyles() {
      return {
        color: this.color,
        background: '#132839',
      };
    },
    buttonStyles() {
      return {
        color: this.color,
        background: this.background,
      };
    },
    formatedDate() {
      const dayOfWeek = this.date
        .toLocaleDateString('es-ES', { weekday: 'long', timeZone: 'UTC' })
        .split(', ')[0]
        .substring(0, 3);

      const month = new Intl.DateTimeFormat('es-ES', { month: 'short', timeZone: 'UTC' })
        .format(this.date)
        .split('.')[0];

      return { month, dayOfWeek };
    },
    probsContents() {
      return this.percentages.map(p => `${p}%`);
    },
    isPreMatch() {
      return !(this.isLive || this.gameStatus !== 4);
    },
    isLive() {
      return this.gameStatus === 4 && this.isGameLive;
    },
    isPostMatch() {
      return this.gameStatus === 1 || this.gameStatus === 0;
    },
    dynamicClasses() {
      const dynamicClasses = [];
      if (this.isSingleGame) {
        dynamicClasses.push('single-game');
        if (this.containerWidth < 451) {
          dynamicClasses.push('first-break-point');
        }
      } else {
        if (this.containerWidth < 681) {
          dynamicClasses.push('first-break-point');
          if (this.containerWidth < 636) {
            dynamicClasses.push('second-break-point');
            if (this.containerWidth < 446) {
              dynamicClasses.push('third-break-point');
            }
          }
        }
      }
      return dynamicClasses;
    },
  },
  methods: {
    ...mapMutations('general', ['setPreviewSectionAnalytics']),
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    changeNameReferee(name) {
      if (name === 'Sin designar') {
        return name;
      }
      let nameRefereePrint = '';
      if (name != null) {
        const nameTrim = name.trim();
        const auxReferee = nameTrim.split(', ');
        const apellidoAuxReferee = auxReferee[0].split(' ');
        const nameAuxReferee = auxReferee[1].split(' ');
        let auxNameInitials = '';
        for (let index = 0; index < nameAuxReferee.length; index++) {
          auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
        }
        nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
      }
      return nameRefereePrint;
    },
    setOpenMedia(gameId) {
      let jsonConfig = {
        seasonId: this.getSeasonSelected,
        tournaments: this.tournamentsForMediaPlayer,
        mainSectionType: 1,
        playListType: 1,
        gameIds: [gameId],
        playerIds: [],
        teamId: 0,
        matchResult: [],
        playData: {},
        advancedFilter: {},
      };
      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
    onClickViewStats() {
      this.$emit('action', { game: this.game.game_id, status: this.game.game_status });
      this.setPreviewSectionAnalytics('Calendar');
    },
  },
};
</script>

<style lang="scss">
.calendar-match-active-time {
  width: 100%;
  box-sizing: content-box;
  display: flex;
  font-family: Avenir-Regular, sans-serif;
  font-size: 1rem;

  & .date {
    text-align: center;
    width: 15%;
    min-width: 44px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 0.5rem;

    & * {
      cursor: default;
    }

    &__dayofweek,
    &__month {
      text-transform: uppercase;
      font-family: Avenir-Demi, sans-serif;
      font-size: 0.75rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: -0.24px;
      margin: 0.6em;
    }

    &__day {
      font-family: Circular-Std, sans-serif;
      font-size: 2.25rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.5;
      letter-spacing: -0.72px;
    }
  }

  & .game {
    width: 82%;
    display: flex;
    flex-direction: column;
    border: solid 0.8px #d2d2d2;
    border-radius: 6px;
    padding: 0.3em;

    & > div {
      &:first-child {
        justify-self: center;
      }
      &.actions__info-button {
        margin-right: 1em;
      }
    }

    &__active-time {
      display: grid;
      grid-template-columns: 78% 18%;
      column-gap: 4%;
      row-gap: 5px;
      margin-bottom: 4px;

      &__status-and-teams {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;

        &__status {
          position: absolute;
          font-family: Avenir-Demi, sans-serif;

          & > .live {
            padding: 0.6em 0.5em 0.3em;
            display: flex;
            font-size: 8px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.11;
            letter-spacing: -0.16px;
            text-align: center;
            color: #132839;
            border-radius: 5px;
            background-color: #cbfb48;

            & > div:first-child {
              margin-top: 1px;
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background-color: #5277fc;
              margin-right: 4px;
            }
          }

          & > .pre-match {
            margin-top: 0.5em;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.89;
            letter-spacing: -0.2px;
            text-align: center;
            color: #000;
          }

          & > .ended {
            padding: 4px 7px 2px;
            border-radius: 5px;
            border: solid 1px #000;
            font-size: 8px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.11;
            letter-spacing: -0.16px;
            text-align: center;
            color: #132839;
          }
        }

        &__teams {
          width: 100%;
          display: flex;
          justify-content: space-around;
          align-items: flex-end;
          padding-top: 14px;

          &__logo {
            height: 30px;
            width: 30px;

            & > img {
              height: 30px;
              width: 30px;
            }
          }

          &__score {
            padding-bottom: 0.4em;
            font-family: Circular-Std-Bold, sans-serif;
            font-size: 17px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.71;
            letter-spacing: -0.34px;
            text-align: center;
            color: #132839;
          }
        }
      }

      &__time-info {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
      }

      &__time-info-pre-match {
        display: grid;
        grid-template-columns: 35% 35%;
        column-gap: 30%;
        margin-bottom: 4px;
      }

      &__total {
        text-align: center;
        padding: 0.6em 0 0.4em;
        font-family: Avenir-Medium, sans-serif;
        font-size: 12px;
        border-radius: 3px;
        background-color: #dfe7ea;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.74;
        letter-spacing: -0.24px;

        &.is-live {
          background-color: #007195;
          color: white;
        }

        &.is-active {
          color: white;
          font-family: Avenir-Bold, sans-serif;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.74;
          letter-spacing: -0.24px;
        }
      }
    }

    &__others {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin-top: 5px;

      &__text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        background-color: #132839;
        color: white;
        font-family: Avenir-Demi, sans-serif;
      }

      &__minutes {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        color: #132839;
        border: solid 1px #132839;
        font-family: Avenir-Demi, sans-serif;
      }

      &.is-pre-match {
        grid-template-columns: 40% 60%;

        & > div.game__others {
          &__text {
            display: flex;
            justify-content: space-around;
            background-color: #dfe7ea;
            color: #132839;
            padding: 0.5em 0 0.5em;

            & > img {
              width: 18px;
              height: 13px;
            }

            & > div {
              line-height: 1;
            }
          }

          &__minutes {
            border: solid 1px #dfe7ea;
            font-size: 11px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: -0.22px;
            text-align: center;
            color: #132839;

            & span {
              &:first-child {
                font-family: Avenir-Medium, sans-serif;
              }

              &:last-child {
                font-family: Avenir-Bold, sans-serif;
              }
            }
          }
        }
      }
    }

    &__x-TA {
      margin-top: 8px;
      display: grid;
      grid-template-columns: 1fr min-content 1fr;
      border-radius: 6px;
      background-color: #132839;
      color: white;
      font-family: Avenir-Demi, sans-serif;
      font-size: 12px;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.81;
      letter-spacing: -0.22px;
      text-align: center;
      padding: 1em 0 0.8em;

      & > div {
        justify-self: center;

        &:last-child {
          font-family: Avenir-Bold, sans-serif;
        }
      }
    }

    &__referee {
      margin-top: 8px;
      display: grid;
      grid-template-columns: 40px min-content 1fr;
      border-radius: 7px;
      border: solid 1px #dfe7ea;

      & > div {
        align-self: center;
      }

      &__icon {
        width: 18px;
        height: 13px;
        justify-self: center;
        align-self: center;

        & > img {
          width: 18px;
          height: 13px;
        }
      }

      & .v-separator {
        border-left: dotted 0.5px #d2d2d2;
        height: 80%;
      }

      &__name {
        font-family: Avenir-Medium, sans-serif;
        color: #132839;
      }
    }

    &__container {
      width: 100%;
      margin: 0 0.7rem;
      position: relative;
      display: flex;
      justify-content: center;

      & * {
        cursor: default;
      }
    }

    &__live-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2px auto auto;
      padding: 0 0.5em;
      border-radius: 0.3em;
      font-size: 0.8rem;
      line-height: 1.75em;
      font-weight: normal;
      font-family: Avenir-Medium, sans-serif;
      background: #3c3c3c;
      top: -0.9em;

      & span:first-child {
        color: #fff;
        padding-top: 0.1em;
      }

      & span:last-child {
        background-color: #77a405;
        height: 0.8em;
        width: 0.8em;
        border-radius: 50%;
        margin-left: 0.5em;
      }
    }

    &__time {
      display: block;
      top: -0.5em;
      font-family: Avenir-Demi, sans-serif;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: -0.28px;
      text-align: center;
      color: black;
    }

    &__teams {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr max-content 1fr;
      color: #132839;

      &__team-info {
        width: 100%;
        justify-self: center;
        display: flex;
        align-items: center;
        justify-content: center;

        &__name {
          margin: 0.3em 0.25em;
          white-space: nowrap;
        }

        &__score {
          display: flex;
          justify-content: center;
          align-items: center;

          & .penalties {
            font-family: Avenir-Medium, sans-serif;
            font-size: 16px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.13;
            letter-spacing: -0.32px;
            text-align: center;
            color: #132839;
          }
        }

        &.home {
          flex-direction: row-reverse;
        }

        & .team-stats {
          width: 100%;
          max-width: 6.75rem;
        }
      }
      &__vs {
        margin: 0 1rem 0.5em;
        align-self: flex-end;
        font-family: Circular-Std-Book, sans-serif;
        font-size: 1.6875rem;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.67;
        letter-spacing: -0.54px;
      }
      &__contvs {
        display: inline-block;
        &__vs {
          margin: 3px 1rem 0.09rem 0.5em;
          align-self: flex-end;
          font-family: Circular-Std-Book, sans-serif;
          font-size: 1.6875rem;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.67;
          letter-spacing: -0.54px;
        }
        &__buttom-summary {
          width: 86px;
          height: 22px;
          border-radius: 25px;
          background-color: #cbee6d;
          display: inline-flex;
          font-family: 'Avenir-Medium';
          font-size: 11px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 22px;
          letter-spacing: -0.22px;
          text-align: center;
          color: #132839;
          justify-content: center;
          span {
            cursor: pointer;
          }
          & > img {
            width: 14px;
            height: 14px;
            margin-top: 4px;
            margin-left: 6px;
            cursor: pointer;
          }
          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }

      &__logo {
        margin: 0 1rem 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        &.home {
          margin: 0 0 0 1rem;
        }

        & > img {
          height: 3rem;
          width: 3rem;
        }
      }

      & .game__score {
        font-family: Avenir-Bold, sans-serif;
        font-size: 2em;
        line-height: 0.2;
        padding-top: 0.2em;
        margin: 0 0.25em;
      }
    }

    &__stats {
      margin: auto;
      &-xg {
        display: flex;
        justify-content: space-between;
        width: 100%;
        & > div {
          width: 48%;
        }
      }
    }
  }

  & .actions__info-button {
    box-sizing: border-box;
    font-family: Avenir-Demi, sans-serif;
    font-size: 0.75rem;
    color: #132839;
    text-align: center;
    background: rgb(254, 208, 37);
    background: linear-gradient(180deg, rgba(254, 208, 37, 1) 0%, rgba(240, 178, 17, 1) 100%);
    padding: 0.9em 1em 0.6em;
    height: fit-content;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: -0.32px;
    border-radius: 0.2em;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.19);
    cursor: pointer;
    &.live {
      background-color: #77a405;
      color: #fff;
    }
  }

  &.single-game {
    & .game {
      width: 96%;
      padding: 0.3em;
      &__live-tag {
        top: 0.1em;
      }

      &__time {
        top: 0.8em;
        font-size: 0.875rem;
      }

      &__teams {
        margin-top: 0.8rem;
        &__team-info {
          flex-direction: column;
          align-items: center;

          & .team-stats {
            max-width: 8.875rem;
          }
        }
        &__vs {
          font-family: Circular-Std-Bold, sans-serif;
          font-size: 2rem;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.55;
          letter-spacing: -0.66px;
          margin: 1.5rem 0.5em;
          color: black;
          align-self: flex-start;
        }
        &__contvs {
          display: inline-block;
          &__vs {
            font-family: Circular-Std-Bold, sans-serif;
            font-size: 2rem;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.55;
            letter-spacing: -0.66px;
            margin: 1.5rem 1.5rem 1rem 1.5rem;
            color: black;
            align-self: flex-start;
          }
        }

        &__logo {
          margin: 0 0 0.1em 0;

          & > img {
            height: 5.5em;
            width: 5.5em;
          }

          &.home {
            margin: 0 0 0.1em 0;
          }
        }

        & .game__score {
          font-size: 2em;
          margin: 0.8em 0.3em 0.9em;
        }
      }
    }

    & .actions__info-button {
      margin-top: 1em;
      padding: 1em;
    }

    &.first-break-point {
      display: grid;
      grid-template-columns: max-content 1fr;

      & .date {
        width: 2.75rem;
        border-radius: 5px;

        &__dayofweek,
        &__month {
          font-size: 0.5rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.27;
          letter-spacing: -0.14px;
          margin: 0.8em;
        }

        &__day {
          font-size: 1.125rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.72;
          letter-spacing: -0.36px;
        }
      }

      & .game {
        width: 96%;
        padding: 0.3em;

        &__live-tag {
          top: -0.2em;
          align-items: center;
          font-size: 0.6rem;

          & span:last-child {
          }
        }

        &__time {
          top: 0.3em;
          font-size: 0.6rem;
        }

        &__teams {
          margin-top: 0.3em !important;
          min-height: 5.375em;
          &__team-info {
            & .team-stats {
              max-width: 4.375rem;
            }
          }
          &__vs {
            align-self: flex-end;
            font-size: 1.125rem;
            line-height: 0.61;
            letter-spacing: -0.36px;
            margin: 0 0.5em 2.8em;
          }
          &__contvs {
            display: inline-block;
            &__vs {
              align-self: flex-end;
              font-size: 1.125rem;
              line-height: 0.61;
              letter-spacing: -0.36px;
              margin: 31px 0.5em 0.5em 0.5em;
            }
          }
          &__logo {
            margin: 0 7% 0 0;

            &.home {
              margin: 0 0 0 7%;
            }

            & > img {
              height: 2.75rem;
              width: 2.75rem;
            }
          }
        }
      }

      & .actions__info-button {
        box-sizing: border-box;
        font-size: 0.75rem;
        width: fit-content;
        height: fit-content;
        padding: 0.9em 1em 0.6em;
        border-radius: 0.2em;
        margin-top: 0;
      }
    }
  }

  &.first-break-point {
    & .date {
      width: 10%;
    }
    & .game {
      width: 87%;
    }

    & .actions__info-button {
      box-sizing: border-box;
      font-size: 0.75rem;
      width: fit-content;
      height: fit-content;
      padding: 0.9em 1em 0.6em;
      border-radius: 0.2em;
      margin-top: 0;
    }

    &.second-break-point {
      display: grid;
      grid-template-columns: max-content 1fr;

      & .date {
        width: 2.75rem;

        &__dayofweek,
        &__month {
          font-size: 0.5rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.27;
          letter-spacing: -0.14px;
          margin: 0.8em;
        }

        &__day {
          font-size: 1.125rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.72;
          letter-spacing: -0.36px;
        }
      }

      & .game {
        width: 98%;
        padding: 0.3em;

        &__live-tag {
          top: -0.1em;
          font-size: 0.7em;

          & span:last-child {
            height: 0.6em;
            width: 0.6em;
            margin-left: 0.5em;
          }
        }

        &__time {
          top: 0;
          font-size: 0.6rem;
        }

        &__teams {
          &__team-info {
            & .team-stats {
              max-width: 4.375rem;
            }
          }
          &__vs {
            font-size: 1.125rem;
            line-height: 0.61;
            letter-spacing: -0.36px;
            margin: 0 0.5em 0.8em;
          }
          &__contvs {
            display: inline-block;
            &__vs {
              font-size: 1.125rem;
              line-height: 0.61;
              letter-spacing: -0.36px;
              margin: 4px 0.8em 0.24em 0.8em;
            }
            &__buttom-summary {
              width: 70px;
              height: 20px;
              font-size: 9px;
              border-radius: 29px;
              & > img {
                width: 12px;
                height: 12px;
                margin-top: 4px;
                margin-left: 4px;
              }
              &:hover {
                cursor: pointer;
                opacity: 0.8;
              }
            }
          }

          &__logo {
            margin: 0 7% 0 0;

            &.home {
              margin: 0 0 0 7%;
            }

            & > img {
              height: 2.75rem;
              width: 2.75rem;
            }
          }

          & .game__score {
            font-size: 1.5em;
            padding-top: 0.2em;
          }
        }
      }

      & .actions__info-button {
        box-sizing: border-box;
        font-size: 0.75rem;
        width: fit-content;
        height: fit-content;
        padding: 0.9em 1em 0.6em;
        border-radius: 0.2em;
        margin-top: 0;
      }

      &.third-break-point {
        & .date {
          border-radius: 4px;
        }

        & .game {
          width: 96%;

          &__live-tag {
            top: -0.1em;
            font-size: 0.65em;

            & span:last-child {
              height: 0.6em;
              width: 0.6em;
              margin-left: 0.5em;
            }
          }

          &__time {
            top: 0;
            font-size: 0.6rem;
          }

          &__teams {
            min-height: 86px;
            &__team-info {
              flex-direction: column;
              align-items: center;

              &__score {
                align-items: flex-end;
                & .penalties {
                  font-size: 12px;
                  margin: 2px;
                }
              }
            }
            &__vs {
              margin: 0 0.5em 2.5em;
            }
            &__contvs {
              display: inline-block;
              &__vs {
                margin: 27px 0.5em 0.7em 0.5em;
              }
            }

            &__logo {
              margin: 0 0 0.1em 0;

              &.home {
                margin: 0 0 0.1em 0;
              }
            }

            & .game__score {
              font-size: 1em;
              padding-top: 0.2em;
              margin: 0.5em 0;
            }
          }
        }

        & .actions__info-button {
          margin-right: 0;
        }
      }
    }
  }
}
.separator {
  width: 100%;
  border: dotted 0.5px #d2d2d2;
}
</style>
